export default __webpack_public_path__ + "static/assets/80f6859e6f21b3ecb786657ff4c941c7.gif";